import { render, staticRenderFns } from "./ArtworkDrawer.vue?vue&type=template&id=13dcd4a1&"
import script from "./ArtworkDrawer.vue?vue&type=script&lang=js&"
export * from "./ArtworkDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports